export enum enumCompanyPlacement {
  COMPANY_PAGE,
  ISF,
  ENTRY_SUMMARY,
  CONTINUOUS_BOND,
  SHIPMENT,
  CBP_ASSIGNED_NUMBER_REQUEST,
}
